<template>
    <v-dialog v-model="dialog">
        <v-card>
            <v-app-bar  flat color="transparent">
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="title">
                    Importar XML
                </v-toolbar-title>
            </v-app-bar>

            <v-container> </v-container>

            <v-card-title class="text-h5">
                Selecione o arquivo XML para importação
            </v-card-title>

            <v-file-input
                v-model="file"
                label="Selecione o arquivo XML"
                prepend-icon="mdi-xml"
                variant="filled"
                class="pa-4"
                accept=".xml"
                @change="handleFileUpload(file, $event)"
            ></v-file-input>

            <v-card-actions>
                <v-btn
                    color="error"
                    @click="$emit('close')"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="primary"
                    @click="$emit('confirm', items, codNf, chaveAcesso, numPedido)"
                    :disabled="!file"
                >
                    Importar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue'
export default {
    name: 'RecebimentoDeNotaFiscalImportXmlView',
    props: ['open'],
    data() {
        return {
            dialog: false,
            file: null,
            items: [],
            codNf: '',
            chaveAcesso: '',
            numPedido: '',
            serie: '',
            nfDateEmissao: '',
            nfDataSaiEnt: '',
            icmsTypes: ["ICMS00", "ICMS10", "ICMS20", "ICMS40", "ICMS51", "ICMS60", "ICMS70", "ICMS90"]
        };
    },
    watch: {
        open(newVal) {
            this.file = null;
            this.dialog = newVal;
        }
    },
    methods: {
        handleFileUpload(event) {
            console.log('File selected:', event);
            const file = event;
            const reader = new FileReader();

            reader.onload = (e) => {
                const xmlContent = e.target.result;
                this.parseXML(xmlContent);
            };

            reader.readAsText(file);
        },

        handleConfirm(){
            this.file = null;
            this.$emit('confirm', this.items, this.codNf, this.chaveAcesso, this.numPedido, this.serie, this.nfDataSaiEnt);
        },

        parseXML(xmlStr) {
            this.items = [];
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlStr, "application/xml");

            // Exemplo: pegar o valor de uma tag <nNF>
            const detTags = xmlDoc.getElementsByTagName("det");
            this.codNf = xmlDoc.getElementsByTagName("nNF")[0]?.textContent || '';
            this.chaveAcesso = xmlDoc.getElementsByTagName("chNFe")[0]?.textContent || '';
            this.numPedido = xmlDoc.getElementsByTagName("xPed")[0]?.textContent || '';
            this.serie = xmlDoc.getElementsByTagName("serie")[0]?.textContent || '';
            this.nfDataSaiEnt = xmlDoc.getElementsByTagName("dhSaiEnt")[0]?.textContent || '';

            const xPeds = [];

            for (let i = 0; i < detTags.length; i++) {
                const det = detTags[i];
                const prod = det.getElementsByTagName("prod")[0];

                const impostos = det.getElementsByTagName("imposto")[0];
                //const icms = impostos.getElementsByTagName("ICMS")[0].getElementsByTagName("ICMS00")[0];
                const ipi = impostos.getElementsByTagName("IPI")[0].getElementsByTagName("IPITrib")[0];
                const pis = impostos.getElementsByTagName("PIS")[0].getElementsByTagName("PISAliq")[0];
                const cofins = impostos.getElementsByTagName("COFINS")[0].getElementsByTagName("COFINSAliq")[0];

                console.log('detTags >>> ', det.getElementsByTagName("nItemPed")[0].textContent)


                let icmsValue = null;

                for (const type of this.icmsTypes) {
                    const found = impostos.getElementsByTagName("ICMS")[0].getElementsByTagName(type)[0] //icms.getElementsByTagName(type)[0];
                    if (found) {
                        icmsValue = found;
                        break;
                    }
                }

                const xPedValue = prod?.getElementsByTagName("xPed")[0]?.textContent;
                if (xPedValue) xPeds.push(xPedValue);

                this.items.push({
                    _id: Math.random().toString(36).substring(2, 8),
                    status: 'Pendente',
                    seqitem: det.getAttribute("nItem"),
                    descriptionItem: prod?.getElementsByTagName("xProd")[0]?.textContent,
                    qty: parseFloat(prod?.getElementsByTagName("qCom")[0]?.textContent),
                    //qtyReceived: parseFloat(prod?.getElementsByTagName("qCom")[0]?.textContent),
                    vlrunit: Number(prod?.getElementsByTagName("vUnCom")[0]?.textContent ?? 0),
                    vlrtotal: Number(prod?.getElementsByTagName("vProd")[0]?.textContent ?? 0),
                    seqItemPurchaseOrder: det.getElementsByTagName("nItemPed")[0]?.textContent,
                    codPurchaseOrder: prod?.getElementsByTagName("cProd")[0]?.textContent,
                    nfIndustrializacao: prod?.getElementsByTagName("nNF")[0]?.textContent,
                    iCMSPercICMS: Number(icmsValue?.getElementsByTagName("pICMS")[0]?.textContent ?? 0),
                    iCMSVlrICMS: Number(icmsValue?.getElementsByTagName("vICMS")[0]?.textContent ?? 0),
                    iPIPercIPI: Number(ipi?.getElementsByTagName("pIPI")[0]?.textContent ?? 0),
                    iPIVlrIPI: Number(ipi?.getElementsByTagName("vIPI")[0]?.textContent ?? 0),
                    pISPerc: Number(pis?.getElementsByTagName("pPIS")[0]?.textContent ?? 0),
                    pISVlrPIS: Number(pis?.getElementsByTagName("vPIS")[0]?.textContent ?? 0),
                    cOFINSPerc: Number(cofins?.getElementsByTagName("pCOFINS")[0]?.textContent ?? 0),
                    cOFINSVlrCOFINS: Number(cofins?.getElementsByTagName("vCOFINS")[0]?.textContent ?? 0),
                    unidadeSigla: prod.getElementsByTagName("uCom")[0]?.textContent,
                    ncm: prod.getElementsByTagName("NCM")[0]?.textContent,
                    cfop: prod.getElementsByTagName("CFOP")[0]?.textContent
                })

            }

            console.log('ITEMS >>> ', this.items)
            
            const allEqual = xPeds.every(val => val === xPeds[0]);
            if(!allEqual){
                Vue.prototype.$notify({
                    title: "Não permitido xml com o mesmo pedido de compra.",
                    closeOnClick: true,
                    duration: 3000,
                    positions: "right",
                    type: "error",
                });

                this.file = null;
                this.items = []
            }
        }
    }
}
</script>